import React from 'react';
import { css } from '@emotion/css';
import { color_text_link, color_text_default, color_variants_ocean_light_1, color_text_light } from '../../../constants/colors';
import TemplateSectionStatusModel from '../../../models/templating/TemplateSectionStatusModel';
import _ from 'lodash';
import HorizontalSeparator from '../../../components/structure/HorizontalSeparator';

const completeIcon = require('../../../content/images/templates-icons/complete.svg');
const incompleteIcon = require('../../../content/images/templates-icons/incomplete.svg');

interface AppliedAppSectionSelectorProps {
    sections: TemplateSectionStatusModel[] | any[]
    activeSection: TemplateSectionStatusModel
    isFinishSelected?: boolean
    isStartSelected?: boolean
    disabled?: boolean
    isNew?: boolean
    onChange: (section: TemplateSectionStatusModel) => void
    onFinishSelect: () => void
    onStartSelect: () => void
    firstSectionName?: string
    hideStart?: boolean
}

const AppliedAppSectionSelector: React.FC<AppliedAppSectionSelectorProps> = (props) => {
    const sortedSections = _.sortBy(props.sections ?? [], s => s?.section?.priority);
    const activeIndex = sortedSections.findIndex(s => (props.activeSection?.section?.name && s?.section?.name == props.activeSection?.section?.name) || (props.activeSection?.section?.id && s.section?.id == props.activeSection?.section?.id));
    return (
        <div className={containerStyle}>
            {!props.hideStart &&
                <>
                    <div className={`overview-section section-item ${props.isStartSelected ? 'active' : ''}`} onClick={(props.isNew || props.disabled) ? null : props.onStartSelect}>
                        <p>{props.firstSectionName ? props.firstSectionName : `Overview`}</p>
                    </div>
                    <HorizontalSeparator />
                </>
            }
            {sortedSections?.map((s, idx) => (
                <div
                    key={s.section?.id ?? s.section?.name}
                    className={`section-item ${(props.disabled && ((idx > activeIndex && !props.isFinishSelected) || props.isStartSelected)) ? "disabled" : ""} ${!props.disabled ? "clickable" : ""} ${(props.activeSection?.section?.id && props.activeSection?.section?.id == s.section?.id) || (props.activeSection?.section?.name && props.activeSection?.section?.name == s.section?.name) ? 'active' : ''} ${s.isDisabled || props.isNew ? 'disabled' : ''}`}
                    onClick={() => (s.isDisabled || props.disabled) ? null : props.onChange(s)}>
                    <p>{s.section?.title}</p>
                    <img src={s.isComplete ? completeIcon : incompleteIcon} />
                </div>
            ))}
            <HorizontalSeparator />
            <div className={`review-section section-item ${props.isFinishSelected ? 'active' : ''} ${props.isNew ? 'disabled' : ''}`} onClick={(props.isNew || props.disabled) ? null : props.onFinishSelect}>
                <p>Review</p>
            </div>
        </div>
    );

}

const containerStyle = css`

    padding: 16px;
    .horizontal-separator {
        margin: 8px;
        height: 0.5px;
        width: calc(100% - 16px);
    }

    .section-item {
        display: flex;
        align-items: center;
        border-radius: 4px;
        height: 48px;
        padding: 0 16px;   
        p {
            font-size: 14px;
            line-height: 20px;
            color: ${color_text_default};
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        img {
            margin-right: 0;
            margin-left: auto;
            width: 24px;
            height: 24px;
        }

        .selected-indicator {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: ${color_text_link};
            margin-right: 8px;
            margin-left: auto;
        }
        
        &.active {
            background: ${color_variants_ocean_light_1};
            p {
                color: ${color_text_link}
            }
        }

        &.clickable {
            cursor: pointer;
        }

        &.disabled {
            img {
                display: none;
            }
            p {
                color: ${color_text_light};
            }
        }
        &.review-section {
            margin-bottom: 64px;
        }
    }

`

export default AppliedAppSectionSelector;